import React, { useMemo, useRef, useState } from "react";
import styled from "styled-components";
import image from "./assets/logo_primary_background_1.png";
import hide from "./assets/hide.png";
import queryString from "query-string";
import axios from "axios";

const Container = styled.div`
  background-color: #222222;
  display: "flex";
  align-items: "center";
  align-content: "center";
  align-self: center;
  justify-content: "center";
  margin: auto;
  width: 100vw;
  color: white;
  font-family: "Oxanium";
  min-height: 100vh;
  padding-bottom: 50px;
  img {
    padding-top: 100px;
    display: block;
    margin-left: auto;
    margin-right: auto;
  }
  h1 {
    color: white;
    margin-right: auto;
    margin-left: auto;
    width: 50%;
    text-align: center;
    font-size: 27px;
    font-weight: bolder;
  }
  div.outer {
    margin: auto;
    flex-direction: column;
    @media only screen and (min-width: 600px) {
      width: 50%;
    }
    justify-content: center;
    align-items: center;
    align-self: center;
    align-items: center;
  }
  .max {
    max-width: 300px;
    margin: 10px auto;
    p {
      text-align: center;
    }
  }
  .text-message {
    max-width: 300px;
    margin: 5px auto 0px;
    p {
      font-size: 10px;
    }
  }
  .text-label {
    max-width: 300px;
    margin: 0px auto 0px;
    p {
      font-size: 14px;
    }
  }
  p {
    color: white;
  }

  a {
    text-decoration: none;
    color: white;
  }
  button {
    background-color: yellow;
    border-radius: 12px;
    outline: none;
    border-style: none;
    width: 100%;
    cursor: pointer;
    padding: 10px;
  }
`;

const StyledInput = styled.input`
  display: block;
  padding: 10px;
  background-color: #313131;
  border-style: none;
  margin-top: 5px;
  margin-bottom: 5px;
  border-radius: 12px;
  outline: none;
  width: 100%;
  color: white;
`;
const InputDiv = styled.div`
  background-color: #313131;
  margin-top: 0px;
  margin-bottom: 0px;
  border-radius: 12px;
  margin-left: auto;
  margin-right: auto;
  flex-direction: row;
  display: flex;
  align-items: center;
  justify-content: space-between;
  label {
    margin-right: 15px;
    color: #838282;
    font-size: 14px;
    line-height: 17px;
  }
  max-width: 300px;
  div.image-label {
    display: flex;
    flex-direction: row;
    img {
      padding: 0;
      margin: 0;
      margin-right: 10px;
    }
  }
`;

const Input = (props) => {
  const inputRef = useRef();
  return (
    <InputDiv
      id={props.id}
      style={
        props.match !== undefined
          ? props.match
            ? { borderStyle: "solid", borderWidth: "2px", borderColor: "green" }
            : { borderStyle: "solid", borderWidth: "2px", borderColor: "red" }
          : {}
      }
    >
      <div>
        <StyledInput ref={inputRef} {...props}></StyledInput>
      </div>
      <div className="image-label">
        <label onClick={() => inputRef.current.focus()} htmlFor={props.id}>
          {props.label}
        </label>
        {props.image && (
          <img onClick={props.show} src={hide} alt="show-password" />
        )}
      </div>
    </InputDiv>
  );
};
export const DeleteAccountData = (props) => {
  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(undefined);
  const [error, setError] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(
        `https://api.sportreact.com/api/v1/auth/delete-account-data`,
        {
          email,
        },
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            "content-type": "application/json",
          },
        }
      );
      if (response.status < 400) {
        setSuccess(true);
      } else {
        console.log(response);
        setSuccess(false);
      }
    } catch (e) {
      setError(e.response.data.message);
      setSuccess(false);
      console.log(e.response.data.message);
    }
  };
  return (
    <Container>
      {success === undefined ? (
        <div className="outer">
          <div>
            <img src={image} alt="logo" width={"130px"}></img>
          </div>
          <h1>Delete your account data!</h1>
          <div className="max">
            <p>Enter your account email and delete your associated data!</p>
          </div>
          <form onSubmit={onSubmit}>
            <div className="text-label">
              <p>E-mail</p>
            </div>

            <Input
              id="text"
              value={email}
              type={"email"}
              onChange={(event) => setEmail(event.target.value)}
              label="Email"
              image
            />
            <div className="max">
              <button>Delete account data</button>
            </div>
            <div className="max">
              <p>1.Enter your account email and press "Delete account data"</p>
              <p>
                2.Check your inbox, there should be an email with delete account
                url.
              </p>
              <p>
                3.Once you opened delete url, all your account data will be
                deleted.
              </p>
              <ul>
                <li>profile picture</li>
                <li>workouts you created </li>
                <li>workout session results you saved</li>
                <li>workout pictures</li>
              </ul>
            </div>
          </form>
          <div className="max">
            <p>Questions?</p>
            <p>
              Email us at{" "}
              <a href="mailto: info@sportreact.com">info@sportreact.com</a>
            </p>
          </div>
        </div>
      ) : success === false ? (
        <div className="outer">
          <div>
            <img src={image} alt="logo" width={"130px"}></img>
          </div>
          <h1>Delete your account!</h1>
          <div className="max">
            <p>{error}</p>
          </div>
          <div className="max">
            <button
              onClick={(e) => {
                e.preventDefault();
                setError("");
                setEmail("");
                setSuccess(undefined);
              }}
            >
              Try again
            </button>
          </div>
        </div>
      ) : (
        <div className="outer">
          <div>
            <img src={image} alt="logo" width={"130px"}></img>
          </div>
          <h1>Delete your account data!</h1>
          <div className="max">
            <p>Check your email to continue deleting your account data!</p>
          </div>
          <div className="max">
            <button
              onClick={(e) => {
                e.preventDefault();
                setError("");
                setEmail("");
                setSuccess(undefined);
              }}
            >
              Try again
            </button>
          </div>
        </div>
      )}
    </Container>
  );
};
